<template>
    <main id="mainCtrl">
        <div v-cloak class="nav-tabs-custom">
            <ul class="nav nav-tabs">
                <li :class="{'active': activeType === 'new'}" @click.stop.prevent="setType('new')" id="tabNew">
                    <a href="#">Новые</a>
                </li>
                <li :class="{'active': activeType === 'published'}" @click.stop.prevent="setType('published')" id="tabPublished">
                    <a href="#">Опубликованные</a>
                </li>
                <li :class="{'active': activeType === 'unpublished'}" @click.stop.prevent="setType('unpublished')" id="tabUnpublished">
                    <a href="#">Отклоненные</a>
                </li>
            </ul>
        </div>

        <v-table id="questionsListTable"
                 :default-filter="{type: 'new'}"
                 request-uri="questionsList/getList"
                 pagesize="10"
                 :lazycount="true"
                 @clear-table-filter="activeType = 'new'"
                 @updated="setQuestionsHeight"
                 ref="table">
            <template v-slot:header>
                <v-tr>
                    <v-th name="number" width="80">
                        № вопроса
                    </v-th>
                    <v-th name="user_name">
                        ФИО пациента
                    </v-th>
                    <v-th name="title">
                        Заголовок
                    </v-th>
                    <v-th name="text">
                        Текст вопроса
                    </v-th>
                    <v-th name="is_payable">
                        Вид
                    </v-th>
                </v-tr>
                <v-tr>
                    <v-th name="number" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>

                    <v-th name="user_name" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>

                    <v-th name="title" :debounce="true"  v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>

                    <v-th name="text" :debounce="true"  v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>

                    <v-th name="is_payable" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options="[
                                { value: '', text: '\u00a0' },
                                { value: 'PAYABLE', text: 'Платный' },
                                { value: 'FREE', text: 'Бесплатный' },
                                { value: 'INDIVIDUAL', text: 'Индивидуальный' },
                                { value: 'INDIVIDUAL_AND_PAYABLE', text: 'Индивидуальный + платный' },
                            ]"
                        ></v-select>
                    </v-th>
                </v-tr>
            </template>

            <template v-slot:row="{ item, index }">
                <v-tr>
                    <v-td>
                        <Question :key="index"
                                  :item="item"
                                  :specialities="specialities"
                                  @updated="updateTable"/>
                    </v-td>
                </v-tr>
            </template>
        </v-table>
    </main>
</template>

<script>
import Question from "./components/Question.vue";

export default {
    components: {
        Question
    },
    props: {
        specialities: {
            type: Array,
            required: true,
        }
    },
    data() {
        return {
            activeType: 'new',
        }
    },
    methods: {
        setType: function (type) {
            this.activeType = type;
            this.$refs.table.filter.type = type;
            this.updateTable();
        },
        updateTable() {
            this.$refs.table.update();
        },
        setQuestionsHeight() {
            setTimeout(() => {
                document.querySelectorAll('.question-title').forEach(el => {
                    el.dispatchEvent(new Event('blur', { bubbles: true }));
                });

                document.querySelectorAll('.question-text').forEach(el => {
                    el.dispatchEvent(new Event('blur', { bubbles: true }));
                    el.style.height = '53px';
                    el.style.height = 5 + el.scrollHeight + 'px';
                });
            }, 100)
        }
    },
    mounted() {
        let defaultFilters = localStorage.getItem(`${location.pathname}@vuetable#questionsListTable`);
        if (defaultFilters) {
            defaultFilters = JSON.parse(defaultFilters)?.filter;

            this.activeType = defaultFilters?.type ?? 'new';
        }
    }
}
</script>

<style lang="scss">
#questionsListTable {
    .textareaMarkable {
        position: relative;
        overflow: hidden;
    }
    .textareaMarkable textarea {
        font-size: 16px;
        padding: 3px;
        position: relative;
    }
    .textareaMarkable div {
        font-size: 16px;
        padding: 4px;
        position: absolute;
        top: 0;
        color: transparent;
        height: auto;
        width: 100%;
        pointer-events: none;
        white-space: pre-wrap;
        word-wrap: break-word;
    }
    .textareaMarkable div mark {
        color: transparent;
    }
    .inputLargeMarkable {
        position: relative;
        overflow: hidden;
    }
    .inputLargeMarkable input {
        font-size: 24px;
        font-weight: 700;
        position: relative;
    }
    .inputLargeMarkable div {
        font-size: 24px;
        font-weight: 700;
        padding: 0;
        position: absolute;
        top: 0;
        color: transparent;
        height: 0;
        pointer-events: none;
    }
    .inputLargeMarkable div mark {
        color: transparent;
    }
}
</style>
